import { useCallback } from 'react';

import {
  StyledToggleCircle,
  StyledLabel,
  StyledToggle,
  StyledRoot,
  StyledInput,
  StyledRealLabel,
  StyledValue,
  StyledToggleWrapper,
} from './styles';
import { ToggleProps } from './types';

export function Toggle({
  className = '',
  label = '',
  checked = false,
  value = '',
  name = '',
  small = false,
  disabled = false,
  inputProps = undefined,
  onChange: onChangeProp = undefined,
}: ToggleProps) {
  const onChange = useCallback(() => {
    if (onChangeProp) {
      onChangeProp(!checked, value, name);
    }
  }, [
    checked,
    value,
    name,
    onChangeProp,
  ]);

  return (
    <StyledRoot className={className}>
      <StyledLabel>
        {!!label && <StyledRealLabel $disabled={disabled}>{label}</StyledRealLabel>}
        <StyledInput
          name={name}
          value={value}
          checked={checked}
          type="checkbox"
          onChange={onChange}
          disabled={disabled}
          {...inputProps}
        />
        <StyledToggleWrapper>
          <StyledToggle $isSmall={small} $disabled={disabled} $checked={checked}>
            <StyledToggleCircle>
              {small && checked && (
                <svg width="6" height="6" viewBox="0 0 6 6" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.4375 4.49999L0.75 2.81249L1.01513 2.54736L2.4375 3.96955L4.98488 1.42236L5.25 1.68749L2.4375 4.49999Z" />
                </svg>
              )}
            </StyledToggleCircle>
          </StyledToggle>
          {value && (
            <StyledValue $disabled={disabled}>
              {value}
            </StyledValue>
          )}
        </StyledToggleWrapper>

      </StyledLabel>
    </StyledRoot>
  );
}
